"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRunQuery = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
const react_1 = require("react");
function useRunQuery() {
    const { data, isLoading, error, post } = (0, core_ui_1.useApiPost)('queries/run');
    const runQuery = (0, react_1.useCallback)((expressionMap, rawOnly) => {
        post({ expressionMap, rawOnly });
    }, [post]);
    const runPaginatedQuery = (0, react_1.useCallback)((expressionMap) => {
        post({ expressionMap, returnType: 'paginated' });
    }, [post]);
    const runQueryGetOne = (0, react_1.useCallback)((expressionMap) => {
        post({ expressionMap, returnType: 'one' });
    }, [post]);
    return {
        queryData: data,
        isRunningQuery: isLoading,
        runQueryError: error,
        runQuery,
        runPaginatedQuery,
        runQueryGetOne
    };
}
exports.useRunQuery = useRunQuery;
//# sourceMappingURL=useRunQuery.js.map